import {authChoiceErrorString} from "../../AuthErrors";
import {Logger} from "../../Logger";
import { logConstants } from "../../../utils/Constants";
export class AuthChoice{
    private protocol: string;
    private location: string;

    constructor(protocol: string, location: string){
        if(protocol){
            this.protocol=protocol;
        }
        else{
            Logger.getInstance().write(logConstants.ERROR,authChoiceErrorString.DSAUTH_CHOICE_PROTOCOL_EMPTY);
            throw new Error(authChoiceErrorString.DSAUTH_CHOICE_PROTOCOL_EMPTY);
        }

        if(location){
            this.location=location;
        }
        else{
            Logger.getInstance().write(logConstants.ERROR,authChoiceErrorString.DSAUTH_CHOICE_LOCATION_EMPTY);
            throw new Error(authChoiceErrorString.DSAUTH_CHOICE_LOCATION_EMPTY);
        }
    }

    getProtocol(): string {
        return this.protocol;
    }

    getLocation(): string{
        return this.location;
    }

    validate(protocolType: string): boolean{
        if(protocolType===this.protocol){
            return true;
        }
        return false;
    }
}